import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SocialLoginModule, AuthServiceConfig, GoogleLoginProvider, FacebookLoginProvider} from 'angularx-social-login';
import {environment} from '../../environments/environment';


// Configs
export function getAuthServiceConfigs() {
    // const config = new AuthServiceConfig(
    //     [{
    //         id: FacebookLoginProvider.PROVIDER_ID,
    //         provider: new FacebookLoginProvider(environment.fbClientId)
    //     },
    //       {
    //         id: GoogleLoginProvider.PROVIDER_ID,
    //         provider: new GoogleLoginProvider(environment.gmailClientId)
    //       }
    //     ]);
    const config = new AuthServiceConfig(
        [{
          id: FacebookLoginProvider.PROVIDER_ID,
          provider: new FacebookLoginProvider(environment.fbClientId)
        }]);
    return config;
}

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        SocialLoginModule
    ],
    providers: [
        {
            provide: AuthServiceConfig,
            useFactory: getAuthServiceConfigs
        }
    ]
})
export class SocialModule {
}
